import { AbstractControl, ValidatorFn } from '@angular/forms'

export function cpfValidator(): ValidatorFn {
  return (control: AbstractControl): Record<string, any> | null => {
    const cpf = control.value?.replace(/\D/g, '')

    if (!cpf || cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
      return { invalidCpf: { value: control.value } }
    }

    let sum = 0
    let remainder

    for (let i = 1; i <= 9; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (11 - i)
    }
    remainder = (sum * 10) % 11
    if (remainder === 10 || remainder === 11) remainder = 0
    if (remainder !== parseInt(cpf.substring(9, 10))) {
      return { invalidCpf: { value: control.value } }
    }

    sum = 0
    for (let i = 1; i <= 10; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (12 - i)
    }
    remainder = (sum * 10) % 11
    if (remainder === 10 || remainder === 11) remainder = 0
    if (remainder !== parseInt(cpf.substring(10, 11))) {
      return { invalidCpf: { value: control.value } }
    }

    return null
  }
}
